module.exports = __webpack_public_path__ + "static/media/evoplay.35b33759.jpeg";